<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="upload-modal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ファイルアップロード</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="!sections.length">
                        <div class="form-group">
                            <label>アップロードファイル選択</label>
                            <div>
                                <div class="btn-group">
                                    <label class="btn btn-secondary" :class="{disabled: uploading}" role="button" style="margin: 0;">
                                        <i class="fas fa-circle-notch fa-spin" v-if="uploading"></i>
                                        <i class="fas fa-file-image" v-else></i>
                                        <span v-if="file.info">
                                            {{$filters.truncate(file.info.name, 30)}}
                                        </span>
                                        <span v-else>小説本文ファイル選択...</span>
                                        <input type="file" ref="text" @change="fileSelected()" accept="text/plain,application/zip" class="d-none" :disabled="uploading" />
                                    </label>
                                    <button type="button" @click="removeFile()" class="btn btn-outline-secondary">
                                        <i class="fas fa-times"></i>
                                        クリア
                                    </button>
                                </div>
                                <button type="button" class="btn btn-outline-primary" @click="upload()" :disable="uploading">
                                    <i class="fas fa-upload"></i>
                                    アップロード開始
                                </button>
                            </div>
                            <div class="small">
                                小説家になろう形式、カクヨム形式、貸し本棚形式は自動解析します。
                            </div>
                        </div>
                        <div class="form-group">
                            <label>手動解析設定</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        本文タイトルが
                                    </span>
                                </div>
                                <input type="text" class="form-control" v-model="pattern" placeholder="例）第" />
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        で始まる
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <label class="btn btn-outline-success btn-sm" :class="{active: remove_pattern}">
                                    <input type="checkbox" v-model="remove_pattern" :value="1" class="d-none" />
                                    <i class="fas fa-check-square" v-if="remove_pattern == 1"></i>
                                    <i class="far fa-square" v-else></i>
                                    タイトル指定文字を削除する
                                </label>
                            </div>
                        </div>
                        <div class="p-2 instruction">
                            <h5>アップロード</h5>
                            <p>
                                小説全体のテキストファイルをアップロードすると、
                                指定した本文タイトルで分解した解析結果を表示します。
                                本文タイトルを指定しないと、本文の文字（全角スペースや「等）以外で始まる行をタイトルとみなします。<br>
                                本文タイトルと同じパターンで検知され、本文がないものは章として登録されます。
                            </p>
                            <h5>自動解析</h5>
                            <p>
                                以下のフォーマットのファイルは自動解析します。
                            </p>
                            <h6>小説家になろう形式</h6>
                            <p>
                                「小説家になろう」のバックアップで、BOMなしUTF-8で出力したファイルを解析します。
                                章登録にも対応します。
                                ノクターン、ムーンライト、ミッドナイトノベルも同一の形式です。
                            </p>
                            <h6>カクヨム形式</h6>
                            <p>
                                「カクヨム」のバックアップを解析します。
                                ダウンロードしたzipファイルをそのままアップロードしてください。
                                章登録にも対応します。
                            </p>
                            <h6>貸し本棚形式</h6>
                            <p>
                                「貸し本棚」のバックアップを解析します。
                                ダウンロードしたzipファイルをそのまま、あるいは本文ファイルをアップロードしてください。
                                章登録にも対応します。
                            </p>
                            <h5>手動解析</h5>
                            <p>
                                自動解析ができない場合、本文タイトルの最初の文字を指定することで、手動解析することができます。
                            </p>
                            <h6>本文タイトル</h6>
                            <p>
                                "第１話「本棚を借りてみた」"<br>
                                エピソードタイトルが上記のような場合は「本文タイトル」に「<b>第</b>」を指定することで、
                                エピソードを分解します。
                            </p>
                            <h6>タイトル指定文字を削除する</h6>
                            <p>
                                "$本棚を借りてみた"<br>
                                エピソードタイトルに一定のパターンが無い場合、上記のように「<b>$</b>」などをテキストファイルのタイトル部分に入力し、
                                「<b>$</b>」を本文タイトルに指定すると、取り込みができます。<br>
                                「タイトル指定文字を削除する」をチェックすると、この指定子「<b>$</b>」をインポートするタイトルから自動削除します。
                            </p>
                            <h5>字下げ</h5>
                            <p>
                                小説本文が全角スペースで字下げされていないと、正常に分解してくれない可能性もあります。
                                その場合は、本文の書式を見直してください。
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div class="form-group text-center py-2">
                            <button type="button" class="btn btn-outline-secondary" @click="clear()">
                                クリア
                            </button>
                            <button type="button" class="btn btn-outline-primary" @click="save()"
                                :disabled="noImport">インポート確定</button>
                        </div>
                        <div class="text-danger" v-if="overLimit">
                            エピソード数が登録可能な最大数を超えています。
                            運営にご相談ください。
                        </div>
                        <ul class="list-group">
                            <li class="list-group-item"
                                v-for="s in sections"
                                :class="{'list-group-item-secondary': !s.body}"
                                :key="s.id">
                                <label>{{s.title}}</label>
                                <div class="text-muted small">{{$filters.truncate(s.body)}}</div>
                            </li>
                        </ul>
                        <div class="text-danger" v-if="overLimit">
                            エピソード数が登録可能な最大数を超えています。
                            運営にご相談ください。
                        </div>
                        <div class="form-group text-center py-2">
                            <button type="button" class="btn btn-outline-secondary" @click="clear()">
                                クリア
                            </button>
                            <button type="button" class="btn btn-outline-primary" @click="save()"
                                :disabled="noImport">インポート確定</button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.instruction {
    h5 {
        font-size: 1rem;
        font-weight: bold;
        border-bottom: 1px solid #ddd;
        padding: .3rem 0;
    }
    p {
        font-size: .8rem;
    }
}
</style>

<script>
export default {
    props: {
        book_id: {
            required: true,
        }
    },
    data() {
        return {
            pattern: "",
            remove_pattern: 0,
            path: null,
            sections: [],
            file: {
                info: null,
                url: null,
            },
            uploading: false,
            selected: null,
            isLoading: false,
        }
    },
    methods: {
        clear() {
            this.path = null;
            this.sections = [];
        },
        upload() {
            this.isLoading = true;
            const fd = new FormData();
            fd.append('text', this.file.info);
            fd.append('url', this.file.url);
            fd.append('pattern', this.pattern);
            fd.append('remove_pattern', this.remove_pattern);
            axios.post("/mypage/book/analyze", fd).then(res => {
                this.isLoading = false;
                this.path = res.data.path;
                this.sections = res.data.sections;
                if (!this.sections.length) {
                    alert.err("ファイル解析に失敗しました。");
                }
            }).catch(err => { alert.err(err.response); this.isLoading = false; });
        },
        save() {
            axios.post(`/mypage/book/analyzed/save`, {
                path: this.path,
                book_id: this.book_id,
            }).then(res => {
                alert.msg(res.data);
                this.clear();
                this.$emit("saved");
                $("#upload-modal").modal("hide");
            }).catch(err => {
                alert.err(err);
            });
        },
        fileSelected() {
            if (this.$refs.text.files[0].size > 1000 * 1024 * 10) {
                alert.err("ファイルサイズが大きすぎます: " + this.getSize(this.$refs.text.files[0].size));
                return;
            }
            this.file.info = this.$refs.text.files[0];
            this.file.url = URL.createObjectURL(this.file.info);
        },
        removeFile() {
            this.file.info = null;
            this.file.url = "";
            this.$refs.text.value = "";
        },
        getSize(filesize) {
            if (filesize >= 1073741824) {
                return Math.round(filesize / 1073741824 * 100) / 100 + "GB";
            } else if (filesize >= 1048576) {
                return Math.round(filesize / 1048576 * 100) / 100 + "MB";
            } else if (filesize >= 1024) {
                return Math.round(filesize / 1024 * 100) / 100 + "KB";
            }
            return filesize + "B";
        },
    },
    computed: {
        noImport() {
            if (!this.path) {
                return true;
            }
            if (this.overLimit) {
                return true;
            }
            return false;
        },
        overLimit() {
            if (this.sections.length > this.$store.state.user.episode_limit) {
                return true;
            }
        }
    },
    mounted() {
        $("#upload-modal").on("show.bs.modal", (e) => {
            this.path = null;
            this.sections = [];
        });
    }
}
</script>